import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryselectService {
  apiToken = '5Q0mYS9XIVbaNW1q8tdgX5p5ifBpR4Q75C31szPAhCIOythyBLVs1fGNI-4ouo7TUmg'
  authToken = ''
  //apiUrl = 'https://www.universal-tutorial.com/api';
  BASE_API_URL = environment.ApiConfig.settings;
  apiUrl = `${this.BASE_API_URL}/settings`
  BASE_API_URL_Student = `${environment.ApiConfig.student}/student`;
  
  public countryList = []
  httpOptions:any;
  initHeaders:any = {
    headers: new HttpHeaders({ 
      "Accept": "application/json",
    "api-token": this.apiToken,
    "user-email": "chanchal.chandanbatwe@softdel.com"
    })     
    
  };
  constructor(private http:HttpClient) { 
    console.log("line no. 28", this.BASE_API_URL_Student);
    this.httpOptions = {
      headers: new HttpHeaders({ 
        'Accept': 'application/json',
        //'Authorization': `Bearer ${data.auth_token}`,
      })     
    };
    this.getCountries().subscribe((data:any) => {
      this.countryList = data
      localStorage.countries = JSON.stringify(data)
    })
  }

  getCountries() {
    return this.http.get(`${this.apiUrl}/countries-states-cities`,this.httpOptions)
  }
  
  getStates(country) {
    return this.http.get(`${this.apiUrl}/countries-states-cities?country=${country}`,this.httpOptions)
  }

  getCities(state) {
    return this.http.get(`${this.apiUrl}/countries-states-cities?state=${state}`,this.httpOptions)
  }

  // shifted from setting service on 20092023
  getStudentEducationClass() {
    return this.http.get(`${this.BASE_API_URL_Student}/profile/education?type=classes`, this.httpOptions);
  }

  getHobbies() {
    return this.http.get(`${this.apiUrl}/hobbies`, this.httpOptions);
  }

  getAspirations() {
    return this.http.get(`${this.apiUrl}/aspirations`, this.httpOptions);
  }

  getReasonsToJoinList() {
    return this.http.get(`${this.apiUrl}/other/reason-to-join`, this.httpOptions);
  }

  getSurveyList() {
    // send header object on 10012023
    return this.http.get(`${this.apiUrl}/other/how-to-know`, this.httpOptions);
  }
  
}
